import { PreautorisationEnLigneStateModel } from '../../../shared/preautorisation-en-ligne.state';
import { PreautorisationModel } from '../../models/preautorisation.model';

interface PreautorisationStep {
  name: string;
  progress: number;
  isPreautResetWithoutWarning?: boolean;
}

export class PreautorisationFlowHelper {
  public static isCoemprunteur(preautorisation: PreautorisationModel) {
    return preautorisation && preautorisation.indCoemprunteur;
  }

  public static isFirstCoemprunteur(preautorisation: PreautorisationModel) {
    return preautorisation && preautorisation.indCoemprunteur && preautorisation.indCoemprunteurPrincipal;
  }

  public static isSecondCoemprunteur(preautorisation: PreautorisationModel) {
    return preautorisation && preautorisation.indCoemprunteur && !preautorisation.indCoemprunteurPrincipal;
  }
}
